import { Component, Host, h, Prop, State } from '@stencil/core';
// import moment from 'moment';
import { DateTime } from "luxon";
import '../loader-component/loader-component'
import '../header-component/header-component';


/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/about-component.PNG)

#### Content Type
nypwebc_ct_announcements
 */

@Component({
  tag: 'listsearch-component',
  styleUrl: 'listsearch-component.css',
  // shadow: true,
  scoped: true
})
export class ListsearchComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"



  @State() items: [];
  @State() isLoading: boolean = true;

  // @State() selectYearValue: any;
  // @State() selectMonthValue: any;
  @State() selectStateValue: string = "";
  @State() initialMessage: string = "Please select the State above to find the Doctors";


  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let currentYear = new Date().getFullYear()
    // let filter = "(nypwebc_PostedDate ge datetime%27" + currentYear + "-01-01T00%3a00%3a00%27) and (nypwebc_PostedDate le datetime%27" + currentYear + "-12-31T00%3a00%3a00%27)"

    // return fetch(siteUrl + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=Modified desc", { headers: { "Accept": "application/json; odata=verbose" } })
    //   .then(response => response.json())
    //   .then(data => {
    //     this.items = data.d.results,
    //       this.isLoading = false
    //     this.selectYearValue = currentYear,
    //       this.selectMonthValue = '99'
    //   });
    this.items = []
    this.isLoading = false

  }

  getStateOptions = () => {

    let stateArray =
      [
        {
          "name": "",
          "abbreviation": ""
        },
        {
          "name": "Alabama",
          "abbreviation": "AL"
        },
        {
          "name": "Alaska",
          "abbreviation": "AK"
        },
        {
          "name": "American Samoa",
          "abbreviation": "AS"
        },
        {
          "name": "Arizona",
          "abbreviation": "AZ"
        },
        {
          "name": "Arkansas",
          "abbreviation": "AR"
        },
        {
          "name": "California",
          "abbreviation": "CA"
        },
        {
          "name": "Colorado",
          "abbreviation": "CO"
        },
        {
          "name": "Connecticut",
          "abbreviation": "CT"
        },
        {
          "name": "Delaware",
          "abbreviation": "DE"
        },
        {
          "name": "District Of Columbia",
          "abbreviation": "DC"
        },
        {
          "name": "Federated States Of Micronesia",
          "abbreviation": "FM"
        },
        {
          "name": "Florida",
          "abbreviation": "FL"
        },
        {
          "name": "Georgia",
          "abbreviation": "GA"
        },
        {
          "name": "Guam",
          "abbreviation": "GU"
        },
        {
          "name": "Hawaii",
          "abbreviation": "HI"
        },
        {
          "name": "Idaho",
          "abbreviation": "ID"
        },
        {
          "name": "Illinois",
          "abbreviation": "IL"
        },
        {
          "name": "Indiana",
          "abbreviation": "IN"
        },
        {
          "name": "Iowa",
          "abbreviation": "IA"
        },
        {
          "name": "Kansas",
          "abbreviation": "KS"
        },
        {
          "name": "Kentucky",
          "abbreviation": "KY"
        },
        {
          "name": "Louisiana",
          "abbreviation": "LA"
        },
        {
          "name": "Maine",
          "abbreviation": "ME"
        },
        {
          "name": "Marshall Islands",
          "abbreviation": "MH"
        },
        {
          "name": "Maryland",
          "abbreviation": "MD"
        },
        {
          "name": "Massachusetts",
          "abbreviation": "MA"
        },
        {
          "name": "Michigan",
          "abbreviation": "MI"
        },
        {
          "name": "Minnesota",
          "abbreviation": "MN"
        },
        {
          "name": "Mississippi",
          "abbreviation": "MS"
        },
        {
          "name": "Missouri",
          "abbreviation": "MO"
        },
        {
          "name": "Montana",
          "abbreviation": "MT"
        },
        {
          "name": "Nebraska",
          "abbreviation": "NE"
        },
        {
          "name": "Nevada",
          "abbreviation": "NV"
        },
        {
          "name": "New Hampshire",
          "abbreviation": "NH"
        },
        {
          "name": "New Jersey",
          "abbreviation": "NJ"
        },
        {
          "name": "New Mexico",
          "abbreviation": "NM"
        },
        {
          "name": "New York",
          "abbreviation": "NY"
        },
        {
          "name": "North Carolina",
          "abbreviation": "NC"
        },
        {
          "name": "North Dakota",
          "abbreviation": "ND"
        },
        {
          "name": "Northern Mariana Islands",
          "abbreviation": "MP"
        },
        {
          "name": "Ohio",
          "abbreviation": "OH"
        },
        {
          "name": "Oklahoma",
          "abbreviation": "OK"
        },
        {
          "name": "Oregon",
          "abbreviation": "OR"
        },
        {
          "name": "Palau",
          "abbreviation": "PW"
        },
        {
          "name": "Pennsylvania",
          "abbreviation": "PA"
        },
        {
          "name": "Puerto Rico",
          "abbreviation": "PR"
        },
        {
          "name": "Rhode Island",
          "abbreviation": "RI"
        },
        {
          "name": "South Carolina",
          "abbreviation": "SC"
        },
        {
          "name": "South Dakota",
          "abbreviation": "SD"
        },
        {
          "name": "Tennessee",
          "abbreviation": "TN"
        },
        {
          "name": "Texas",
          "abbreviation": "TX"
        },
        {
          "name": "Utah",
          "abbreviation": "UT"
        },
        {
          "name": "Vermont",
          "abbreviation": "VT"
        },
        {
          "name": "Virgin Islands",
          "abbreviation": "VI"
        },
        {
          "name": "Virginia",
          "abbreviation": "VA"
        },
        {
          "name": "Washington",
          "abbreviation": "WA"
        },
        {
          "name": "West Virginia",
          "abbreviation": "WV"
        },
        {
          "name": "Wisconsin",
          "abbreviation": "WI"
        },
        {
          "name": "Wyoming",
          "abbreviation": "WY"
        }
      ]

    const yearsArray = []
    stateArray.sort()
    stateArray.forEach((item: any, index: any) => {
      console.log(index)
      yearsArray.push(<option value={item.abbreviation} selected={this.selectStateValue === item.appreviation} >{item.name}</option>)
      console.log(this.selectStateValue)
    })

    return yearsArray
  }

 formarName(user) {
   return user.Last_x0020_name +", " + user.First_x0020_name
 }

 formatAddress(item) {
  return item.Street +", " + item.City +" " + item.Zipcode

 }

  getContents = () => {
    const contentsArray = []
    if (this.items.length > 0) {
      this.items.forEach((item: any, index: any) => {

        console.log(index)
        
        let email=""
        if (item.email)
        {
        
          email= <a href={item.email.Url} > {item.email.Description}</a>
        }
     
        contentsArray.push(
          <div>
            <div class="row">
              <div class="col-md-12">
                <div >
                  <h5> {this.formarName(item)} </h5>
                  <p>{this.formatAddress(item)}</p>
                  {
                  (email) ? email : <div></div>
      }       
                </div>
              </div>
            </div>

            <hr></hr>
          </div>
        )

      })
    }
    else {

      contentsArray.push(<p>  {this.initialMessage} </p>)
    }
    return contentsArray
  }

  handleClick = () => {
    const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    this.initialMessage="No Records found"
    return fetch(siteUrl + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$expand=State0&$select=Last_x0020_name,First_x0020_name,Zipcode,email,City,Street,State0/Title&$Filter=State0/Title eq '" + this.selectStateValue + "'", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results,
          this.isLoading = false
      });

  }

  handleStateSelect(event) {
    console.log(event.target.value);
    this.selectStateValue = event.target.value;
  
    this.handleClick()
  }

  render() {
    let allNewsUrl = this.webpath + "/pages/allitems.aspx?listname=" + this.listname + "&pagetitle=All " + this.sectiontitle + "&images=false"
    if (this.seeallurl) {
      allNewsUrl = this.seeallurl

    }

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }


    return (

      this.isLoading ? <loader-component /> :
        this.header ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={allNewsUrl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div style={{ marginTop: "20px" }} >
                  <div class="col-md-4" >
                    <p>Select State </p>
                    <select onInput={(event) => this.handleStateSelect(event)} class="form-select" aria-label="select year">
                      {this.getStateOptions()}
                    </select>
                  </div>

                  {/* <div class="col-md-4" >
                <p>Select Month </p>
                  <select onInput={(event) => this.handleMonthSelect(event)} class="form-select" aria-label="select month">
                    {this.getMonthOptions()}
                  </select>
                </div> */}
                  {/* <div class="col-md-4" style={{ marginTop: "20px" }} >
                    <button class="btn btn-secondary" type="button" onClick={this.handleClick}> Search </button>
                  </div> */}
                  <div class="col-md-12" style={{ marginTop: "20px" }}>
                    {this.getContents()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              <div style={{ marginTop: "20px" }} >
                <div class="col-md-4" >
                  <p>Select Year </p>
                  <select onInput={(event) => this.handleStateSelect(event)} class="form-select" aria-label="select year">
                    {this.getStateOptions()}
                  </select>
                </div>
                {/* <div class="col-md-4" >
              <p>Select Month </p>
                <select onInput={(event) => this.handleMonthSelect(event)} class="form-select" aria-label="select month">
                  {this.getMonthOptions()}
                </select>
              </div> */}
                {/* <div class="col-md-4" style={{ marginTop: "20px" }} >
                  <button class="btn btn-secondary" type="button" onClick={this.handleClick}> Search </button>
                </div> */}
                <div class="col-md-12" style={{ marginTop: "20px" }}>
                  {this.getContents()}
                </div>
              </div>
            </div>
          </div>
    );
  }

}
